import $ from 'jquery';
import 'slick-carousel'

export default class Gallery {
    constructor() {
        $('.gallery-slider').slick({
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            mobileFirst: false,
            dots: true
        });
    }
}

new Gallery();